import { render } from "./HilfeImWald.vue?vue&type=template&id=3ddc527e"
import script from "./HilfeImWald.vue?vue&type=script&lang=js"
export * from "./HilfeImWald.vue?vue&type=script&lang=js"

import "./HilfeImWald.vue?vue&type=style&index=0&id=3ddc527e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__